export enum Language {
  NL = 'nl',
  EN = 'en',
}
